<template>
    <div>
        <section class="call-to-action call-to-action-default mb-0">
            <div class="container">
                <div class="row">
                    <div class="col-sm-9 col-lg-9">
                        <div class="call-to-action-content text-white">
                            <span v-if="$i18n.locale === 'es'">
                                <h3 class="text-white">Visita <span class="alternative-font">Arte-Contemporary</span>, una experiencia innovadora en el Delta del Ebro</h3>
                                <p class="mb-0 ">Aprovecha al máximo tu visita en La Ràpita!</p>
                            </span>
                            <span v-else-if="$i18n.locale === 'en'">
                                <h3>Visit <span class="alternative-font">Arte-Contemporary</span>, a day well spent in the Ebro Delta</h3>
                                <p class="mb-0">Make the most of your visit in La Ràpita!</p>
                            </span>
                            <span v-else-if="$i18n.locale === 'ca'">
                                <h3>Visita <span class="alternative-font">Arte-Contemporary</span>, una experiència innovadora al Delta de l’Ebre</h3>
                                <p class="mb-0">Treu el màxim profit de la teva visita a la Ràpita!</p>
                            </span>
                        </div>
                    </div>
                    <div class="col-sm-3 col-lg-3">
                        <div class="call-to-action-btn">
                            <router-link :to="{name:'bookingsFrontend'}" class="btn btn-modern text-2 btn-dark text-transform-none">{{ $t('hi.footer_call_action') }}</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <footer id="footer" class="border-top-0 mt-0">
            <div class="bg-light footer-bottom-light-border">
                <div class="container  py-5">
                    <div class="row justify-content-center text-center">
                        <div class="col-sm-4 pt-3">
                            <a href="/" class="logo">
                                <img alt="Arte-contemporary" src="/frontend/img/logo-arte.png" width="226" height="100">
                            </a>
                        </div>
                        <div class="col-sm-4 pt-5">
                            <a href="https://sculpture-network.org/en" target="_blank" rel="nofollow">
                                <img src="/images/logo_claim_en.jpg" class="img-fluid" alt="sculpture network">
                            </a>
                        </div>
                        <div class="col-sm-4">
                            <a href="https://www.kayak.es/Sant-Carles-de-la-R%C3%A0pita.62836.guide" target="_blank" rel="nofollow">
                                <img src="https://www.kayak.com/news/badge/kk/tg005.png" style="max-height:150px" class="img-fluid" alt="Guía de viaje Sant Carles de la Ràpita - KAYAK">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="newsletter footer-bg-color-2 footer-bottom-light-border">
                <b-container>
                    <b-row>
                        <b-col cols="12" class="text-white text-center">
                            <h3>{{ $t('hi.subscribe_title') }}</h3>
                            <p>{{ $t('hi.subscribe_content') }}</p>
                        </b-col>
                    </b-row>
                    <b-form @submit="suscibeSubmit">
                        <b-row>
                            <b-col md="3">
                                <b-input name="name" id="name" :title="$t('hi.your_name')" v-model="suscribe.name" :placeholder="$t('hi.your_name')"></b-input>
                            </b-col>
                            <b-col md="3">
                                <b-input name="cog" id="cog" :title="$t('hi.your_cog')" v-model="suscribe.cog" :placeholder="$t('hi.your_cog')"></b-input>
                            </b-col>
                            <b-col md="3">
                                <b-input type="email" name="email" id="email" :title="$t('hi.your_email')" :placeholder="$t('hi.your_email')" v-model="suscribe.email"></b-input>
                            </b-col>
                            <b-col md="3" class="text-center">
                                <b-button type="button" @click="suscibeSubmit" variant="primary" class="btn-modern w-100 text-uppercase font-weight-bold text-3 py-2 mt-3 mt-md-0">{{ $t('hi.suscribe_newsletter') }}</b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-container>
            </div>
            <div class="footer-bg-color-2 footer-bottom-light-border">
                <div class="container">"
                    <div class="row justify-content-center text-center py-5">
                        <div class="col-md-3 col-sm-6 text-center mb-4 mb-md-0">
                            <i class="fas fa-map-marker-alt text-9 text-color-light mb-3 mt-2"></i>
                            <p class="mb-0">
                                <strong class="text-color-light text-uppercase">{{ $t('hi.address') }}</strong>
                                <span class="d-block text-2 p-relative bottom-3"><a href="https://www.google.es/maps/dir//Arte-Contemporary/@40.6345891,0.5497333,13z/data=!3m1!4b1!4m8!4m7!1m0!1m5!1m1!1s0x12a0fff96c6c5c01:0xaadf7892833b4c44!2m2!1d0.5847528!2d40.6345293" target="_blank" rel="noopener">{{ $t('hi.location') }}</a></span>
                            </p>
                        </div>
                        <div class="col-md-3 col-sm-6 text-center mb-4 mb-md-0">
                            <i class="far fa-clock text-9 text-color-light mb-3 mt-2"></i>
                            <p class="mb-0">
                                <strong class="text-color-light text-uppercase">{{ $t('hi.contactHours') }}</strong>
                                <span class="d-block text-2 p-relative bottom-3">{{ $t('hi.contactHoursDays') }}</span>
                            </p>
                        </div>
                        <div class="col-md-3 col-sm-6 text-center mb-4 mb-md-0">
                            <i class="far fa-clock text-9 text-color-light mb-3 mt-2"></i>
                            <p class="mb-0">
                                <strong class="text-color-light text-uppercase">{{ $t('hi.opening_times') }}</strong>
                                <span class="d-block text-2 p-relative bottom-3" v-html="$t('hi.opening_times_p')"></span>
                            </p>
                        </div>
                        <div class="col-md-3 col-sm-6 text-center">
                            <i class="fas fa-at text-9 text-color-light mb-3 mt-2"></i>
                            <p class="mb-0">
                                <strong class="text-color-light text-uppercase">{{ $t('hi.contactUs') }}</strong>
                                <span class="d-block text-2 p-relative bottom-3"><a href="mailto:info@arte-contemporary.eu" class="text-decoration-none">{{ $t('hi.info_mail') }}</a><br><a href="mailto:corporate@arte-contemporary.eu" class="text-decoration-none">{{ $t('hi.corporate_mail') }}</a></span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer-copyright">
                <div class="container py-2">
                    <div class="row py-4">
                        <div class="col-12 text-center">
                            <ul class="footer-social-icons social-icons social-icons-clean social-icons-icon-light mb-3">
                                <li class="social-icons-facebook"><a href="http://www.facebook.com/ArteContemporary" target="_blank" title="Facebook"><i class="fab fa-facebook-f text-2"></i></a></li>
                                <li class="social-icons-instagram"><a href="http://www.instagram.com/arte_contemporary" target="_blank" title="Instagram"><i class="fab fa-instagram text-2"></i></a></li>
                                <li class="social-icons-tripadvisor">
                                    <div id="TA_socialButtonBubbles636" class="TA_socialButtonBubbles">
                                        <ul id="qx4H2iww5" class="TA_links FmEdHVYP p-0">
                                            <li id="xzIiG43AqK9b" class="OdPdMHE">
                                                <a target="_blank" title="Tripadvisor" href="https://www.tripadvisor.es/Attraction_Review-g644333-d24084478-Reviews-Arte_contemporary_Sculpture_Park-Sant_Carles_de_la_Rapita_Terres_de_l_Ebre_Provi.html">
                                                    <img src="https://static.tacdn.com/img2/brand_refresh/Tripadvisor_logomark.svg" style="max-width: 30px;height: auto;filter: invert(100%);"/>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="col-auto m-auto">
                            <ul id="list-policies" class="col-auto">
                                <li><router-link :to="{name:'cookiesViewFrontend'}">{{ $t('hi.cookie_policy')}}</router-link></li>
                                <li><router-link :to="{name:'privacyPolicyViewFrontend'}">{{ $t('hi.privacy_policy')}}</router-link></li>
                                <li><router-link :to="{name:'legalPolicyViewFrontend'}">{{ $t('hi.legal_policy')}}</router-link></li>
                            </ul>
                        </div>
                        <div class="col-12 text-center">
                            <p>Raó social: Arte Contemporary Sant Carles de la Ràpita SL // CIF: B05395561 // Teléfono: +34 681 34 96 36 // E-Mail: <a href="mailto:jordi@artecontemporary.eu" rel="nofollow">jordi@artecontemporary.eu</a></p>
                            <p>© Copyright {{ (new Date()).getFullYear() }}. {{ $t('hi.footerCopy') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script async
        src="https://www.jscache.com/wejs?wtype=socialButtonBubbles&amp;uniq=636&amp;locationId=24084478&amp;color=green&amp;size=rect&amp;lang=es&amp;display_version=2"
        data-loadtrk onLoad="this.loadtrk=true">
</script>
<script>function loadScript(a){var b=document.getElementsByTagName("head")[0],c=document.createElement("script");c.type="text/javascript",c.src="https://tracker.metricool.com/resources/be.js",c.onreadystatechange=a,c.onload=a,b.appendChild(c)}loadScript(function(){beTracker.t({hash:"f931d9aa40be22c8c0aadb24cb61cb5a"})});</script>
<script>
export default {
    name: "Footer",
    data(){
        return {
            suscribe: {
                email: '',
                name: '',
                cog:''
            }
        }
    },
    methods: {
        async suscibeSubmit(){
            await this.axios.post('/api/suscribe',this.suscribe)
                .then(response=>{
                    //swal suscribed success
                    this.$swal({
                        title: this.$t('hi.successfully_subscribed'),
                        icon: 'success',
                        timer:3000,
                        showCancelButton: false,
                        showCloseButton: false,
                        showConfirmButton: false
                    });
                })
                .catch(error=>{
                    //swal suscribed error
                    this.$swal({
                        title: this.$t('hi.error_subscribed'),
                        text: error.response.data.message,
                        icon: 'error',
                        timer: 3000,
                        showCancelButton: false,
                        showCloseButton: false,
                        showConfirmButton: false
                    })
                })
        }
    }
}
</script>

<style scoped>
#list-policies { list-style: none;margin: 0;padding: 0;}
#list-policies li {float: left}
#list-policies li:not(:first-of-type){padding-left: 5px;}
#list-policies li:not(:first-of-type)::before{content: "  /  ";}
/deep/ .call-to-action.call-to-action-default {background: #718189;}
/deep/ .call-to-action .call-to-action-content {text-align: left;}
/deep/ .call-to-action h3, /deep/ .call-to-action p, /deep/ .call-to-action .alternative-font {color: #fff;}
/deep/ .bottom--50{bottom:-50px;}
/deep/ .newsletter{padding-top:50px;padding-bottom:50px;color:#fff;}
/deep/ .newsletter .form-control::placeholder{color:#000}
/deep/ .newsletter .form-control::-ms-input-placeholder{color:#000}
</style>
